import { Box } from '@gousto-internal/citrus-react'
import React from 'react'

import {
  CWCHero,
  CWCWhatsNewSection,
  CWCHomepageReviewsSection,
  CWCSuppliersSection,
  CWCHowItWorksSection,
  CWCFirstBoxSection,
  DEFAULT_BOXES,
} from '@library/landing-pages'

export type CWCHomepageProps = {
  onSignupCTAClick: () => void
  /** Sign-up destination the section CTAs link to. */
  signupUrl: string
}

/**
 * Assembles the CwC homepage from the landed CWC sections in design order:
 * Hero → What's New → Reviews → Suppliers → How It Works → First Box. Sections stack flush (each
 * owns its own vertical padding), mirroring the existing `Homepage`. First Box is
 * the closing conversion moment before the footer, restating the hero's offer with
 * one final sign-up CTA. This is the only place the CWC sections are composed.
 *
 * The CwC discount offer is fixed (`DEFAULT_BOXES`) and independent of the legacy homepage's
 * tapered-discount experiment — the CwC page is its own acquisition surface behind its own flag.
 * Hero and First Box are experiment-agnostic: they render whatever `discountBoxes` the assembly
 * supplies (per their specs, the caller resolves discount config, not the section).
 */
export function CWCHomepage({ signupUrl, onSignupCTAClick }: CWCHomepageProps) {
  return (
    <Box data-testid="cwcHomepage">
      <CWCHero discountBoxes={DEFAULT_BOXES} signupUrl={signupUrl} onCTAClick={onSignupCTAClick} />
      <CWCWhatsNewSection signupUrl={signupUrl} onCTAClick={onSignupCTAClick} />
      <CWCHomepageReviewsSection />
      <CWCSuppliersSection />
      <CWCHowItWorksSection />
      <CWCFirstBoxSection discountBoxes={DEFAULT_BOXES} onCTAClick={onSignupCTAClick} />
    </Box>
  )
}
